import { css } from "@compiled/react";

import { JiraOverlayTemplate } from "@/components/signup/layouts/product-overlay-template";
import { JoinableSites } from "@/components/signup/site-activation/components/common/joinable-sites";
import { SiteActivation } from "@/components/signup/site-activation/site-activation";

import { Headings } from "../../../components/headings";
import { JoinableSitesText } from "../../../components/joinable-sites-subheading";
import { WelcomeBackText } from "../../../components/welcome-back-heading";

export const CurrentProductJoinableUser = () => {
    return (
        <JiraOverlayTemplate size="sm">
            <div css={containerCss}>
                <Headings
                    main={<WelcomeBackText />}
                    sub={<JoinableSitesText />}
                />
                <SiteActivation
                    CurrentProductJoinableUser={<JoinableSites />}
                    useContactExpandCohortLogic={true}
                />
            </div>
        </JiraOverlayTemplate>
    );
};

const containerCss = css({
    display: "grid",
    gap: "10px"
});
